import Categories from "./Categories"
import LatestPost from "./LatestPost"
import Tags from "./Tags"



interface BlogSidebarProps {
  style_1: boolean;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCategory: React.Dispatch<React.SetStateAction<number | null>>; // ✅ FIXED
  setSelectedTag: React.Dispatch<React.SetStateAction<string>>;
}



const BlogSidebar = ({
  style_1,
  setSearchQuery,
  setSelectedCategory,
  setSelectedTag
}: BlogSidebarProps) => {

  const handleSearch = (value: string) => {
    setSearchQuery(value);
    setSelectedCategory(null);      // reset category
    setSelectedTag('');             // reset tag
  };

  const handleCategorySelect = (categoryId: number) => {
    setSelectedCategory(categoryId);
    setSearchQuery('');             // reset search
    setSelectedTag('');             // reset tag
  };

  const handleTagSelect = (tag: string) => {
    setSelectedTag(tag);
    setSearchQuery('');             // reset search
    setSelectedCategory(null);      // reset category
  };

  return (
    <div className="col-xl-3 col-lg-4">
      <aside className={`blog-sidebar ${style_1 ? "blog-sidebar-two" : ""}`}>
        <div className="blog-widget widget_search">
          <div className="sidebar-search-form">
            <form onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                placeholder="Search by title"
                onChange={(e) => handleSearch(e.target.value)}
              />
              <button><i className="flaticon-search"></i></button>
            </form>
          </div>
        </div>
        <Categories onSelect={handleCategorySelect} />
        <LatestPost />
        <Tags onSelect={handleTagSelect} />
      </aside>
    </div>
  );
};


export default BlogSidebar;
